import { Injectable } from '@angular/core';
import { HttpEvent } from '@angular/common/http';

import { Observable } from 'rxjs';

import { ApiService } from 'src/app/core/services/api/api.service';
import { Template } from 'src/app/models/template';
import { UploadIds } from 'src/app/models/upload';

@Injectable({
  providedIn: 'root',
})
export class TemplatesService {
  getTemplates(studyId: number): Observable<Template[]> {
    return this.apiService.get<Template[]>(`/dashboard/feedback_all/${studyId}`);
  }

  getTemplateById(templateId: number): Observable<Template> {
    return this.apiService.get<Template>(`/dashboard/feedback/${templateId}`);
  }

  createTemplate(template: Template): Observable<Template> {
    return this.apiService.post<Template>(`/dashboard/feedback`, template);
  }

  updateTemplate(template: Template): Observable<Template> {
    return this.apiService.put<Template>(`/dashboard/feedback/${template.id}`, template);
  }

  deleteTemplate(template: Template): Observable<Template> {
    return this.apiService.delete<Template>(`/dashboard/feedback/${template.id}`);
  }

  uploadTemplateLogo(logoFile: File, idsForUpload: UploadIds): Observable<HttpEvent<string[]>> {
    const body: FormData = new FormData();
    body.append('uploads[]', logoFile, logoFile.name);

    return this.apiService.post<HttpEvent<string[]>>(`/dashboard/feedback/upload/${idsForUpload?.studyId}`, body, {
      reportProgress: true,
      observe: 'events',
    });
  }

  importTemplate(studyId: number, importFile: File): Observable<Template> {
    const body: FormData = new FormData();
    body.append('uploads[]', importFile, importFile.name);
    return this.apiService.post<any>(`/dashboard/feedback/import/study/${studyId}`, body);
  }

  exportTemplate(templateId: number): Observable<any> {
    return this.apiService.get<any>(`/dashboard/feedback/export/${templateId}`, { responseType: 'text/json' });
  }

  constructor(private apiService: ApiService) {}
}
